import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura González',
    location: 'Montevideo',
    content: 'Antes perdía horas buscando patrones en grupos de Facebook y nunca encontraba lo que quería. Con esta biblioteca en minutos tengo exactamente lo que necesito. La organización es impecable, no puedo creer que no existiera antes.',
    rating: 5
  }, {
    name: 'Sofía Rodríguez',
    location: 'Salto',
    content: 'Empecé a vender mis amigurumis en la feria del barrio y no sabía cómo ponerles precio. La calculadora de costos me cambió todo. Ahora sé exactamente cuánto cobrar y mis ventas subieron un montón.',
    rating: 5
  }, {
    name: 'Mariana Torres',
    location: 'Paysandú',
    content: 'Lo que más me gustó fue la guía de proveedores locales. Siempre compraba hilos carísimos sin saber dónde conseguir algo mejor. Ahora compro en lugares que no conocía y ahorro bastante cada mes.',
    rating: 5
  }, {
    name: 'Valentina Méndez',
    location: 'Canelones',
    content: 'Soy principiante y siempre me trababa con los patrones en inglés o con instrucciones confusas. Acá todo está en español, paso a paso, con fotos. Terminé mi primer suéter en dos semanas. ¡No lo podía creer!',
    rating: 5
  }, {
    name: 'Gabriela Suárez',
    location: 'Rivera',
    content: 'Llevo 10 años tejiendo y pensé que no iba a aprender nada nuevo. Me equivoqué. Los patrones modernos con talles reales son justo lo que me faltaba. Ya hice tres prendas que quedaron espectaculares.',
    rating: 5
  }, {
    name: 'Camila Pereira',
    location: 'Maldonado',
    content: 'Compré dudando porque ya había gastado plata en otros recursos que no me sirvieron. Pero este es diferente. Se nota que fue hecho por alguien que realmente teje y entiende los problemas que tenemos. Vale cada peso.',
    rating: 5
  }];
  return <section className="py-10 md:py-24 bg-[#F5EBE0]" data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="text-center mb-8 md:mb-16" data-id="element-195">
          <h2 className="text-2xl md:text-4xl font-bold text-[#3D2B1F] mb-3" data-id="element-196">
            Lo que dicen nuestras tejedoras
          </h2>
          <div className="flex justify-center gap-1" data-id="element-197">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-[#C17B5C] fill-current" data-id="element-198" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-199">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-200">
              <Card className="h-full relative pt-10 flex flex-col" data-id="element-201">
                <div className="absolute top-[-16px] left-6 w-10 h-10 bg-[#D4A5A5] rounded-full flex items-center justify-center text-white shadow-lg" data-id="element-202">
                  <Quote className="w-5 h-5" data-id="element-203" />
                </div>
                <div className="flex gap-0.5 mb-3" data-id="element-204">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-[#C17B5C] fill-current" data-id="element-205" />)}
                </div>
                <p className="text-[#6B5A4E] text-sm leading-relaxed mb-4 flex-1" data-id="element-206">
                  "{testimonial.content}"
                </p>
                <div className="border-t border-[#EAE0D5] pt-3 mt-auto" data-id="element-207">
                  <p className="font-bold text-[#3D2B1F] text-sm" data-id="element-208">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-[#8B7355] mt-0.5" data-id="element-209">
                    📍 {testimonial.location}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}